import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { passengerLogout } from 'store/actions/app'
import './Header.scss'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'
import { FaChartBar } from 'react-icons/fa6'

import {
  Button,
  Grid,
  Header,
  Icon,
  Image,
  Menu,
  Popup,
  Segment,
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'

const getAvatar = (passenger) => {
  let name = 'Guest'
  if (passenger) {
    name = passenger?.code
  }
  return `https://ui-avatars.com/api/?name=${name}`
}

const HeaderComponent = (props) => {
  const { t } = useTranslation()
  const {
    passenger,
    passengerLogout,
    setExpand,
    openModal,
    setOpenModal,
    mobileOnly,
    previousExpand,
    setPreviousExpand,
  } = props

  const [modalVisible, setModalVisible] = useState(false)

  let userName = passenger?.code

  return (
    <Menu
      className='NavBar__Header'
      inverted
      borderless
      size='tiny'
      attached='top'
      fixed='top'
    >
      <Menu className='SubMenu__Header' size='mini'>
        <Menu.Item className='NavBar__Item'>
          <Icon
            className='NavBar__Outline'
            name='list'
            size='large'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setExpand((previousExpandedState) => {
                setPreviousExpand(previousExpandedState)
                if (!mobileOnly)
                  return previousExpandedState == 1
                    ? previousExpand == null || previousExpand == 2
                      ? 0
                      : 2
                    : 1
                return !previousExpandedState ? 1 : 0
              })
            }}
          />
        </Menu.Item>
        <Menu.Item fitted position='right' data-tip data-for='dashboard-tooltip'>
          <NavLink
            to={'/passenger/passengers'}
            style={{
              marginLeft: 4,
              padding: '2px 4px',
              borderRadius: '50%',
              fontSize: 15,
            }}
            className='Circle_Icon NavBar__Item'

          >
            <FaChartBar style={{ width: 19, height: 19, transform: "rotate(90deg) scaleX(-1) translateX(-2px)" }} />
          </NavLink>
        </Menu.Item>
        <ReactTooltip id='dashboard-tooltip' place='top' effect='solid'>
          {t('Dashboard')}
        </ReactTooltip>
        <Menu.Item>
          <Header>
            <h4 className='NavBar__Outline'>Geologistic ERP</h4>
            <Header.Subheader className='NavBar__Outline'>
              V 0.19.63
            </Header.Subheader>
          </Header>
        </Menu.Item>
        <Menu.Item fitted position='right'>
          <Icon
            className='Circle_Icon NavBar__Item'
            name='question'
            circular
            onClick={() => {
              setOpenModal(!openModal)
            }}
          />
        </Menu.Item>
      </Menu>
      <Menu.Menu position={mobileOnly ? null : 'right'} borderless size='tiny'>
        <Menu.Item fitted position='right' className='NavBar__Item'>
          <Popup
            onOpen={() => setModalVisible(true)}
            onClose={() => setModalVisible(false)}
            pinned
            on='click'
            trigger={
              <Menu.Item className='NavBar__Item'>
                <Image src={passenger?.sys_company_data?.logo_url} avatar />
              </Menu.Item>
            }
            content={
              <Segment className='NavBar__Outline'>
                <Grid
                  divided='vertically'
                  columns='equal'
                  className='Header_PopUp'
                  style={{ display: 'inline-block', padding: 0 }}
                >
                  <Grid.Row columns={1}>
                    <Grid.Column
                      verticalAlign='middle'
                      textAlign='center'
                      className='Logout__Item'
                    >
                      <Image
                        className='Header_PopUp_Image'
                        src={passenger?.sys_company_data?.logo_url}
                        avatar
                      />
                    </Grid.Column>
                    <Grid.Column
                      verticalAlign='middle'
                      textAlign='center'
                      className='Logout__Item'
                    >
                      <h4 className='NavBar__InvertedOutline'>
                        {userName.toUpperCase()}
                      </h4>
                    </Grid.Column>
                    <Grid.Column
                      verticalAlign='middle'
                      textAlign='center'
                      className='Logout__Item'
                    >
                      <Button
                        className='Header_PopUp_Button'
                        basic
                        icon
                        labelPosition='right'
                        onClick={async () => {
                          await passengerLogout(passenger?.id)
                          props.history.push(`/login_passenger${passenger?.sys_company_data?.logo_token
                            ? '?e=' + passenger?.sys_company_data?.logo_token
                            : ''
                            }`)
                        }}
                      >
                        <Icon name='sign out' />
                        {t('Cerrar sesión')}
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            }
            position='bottom right'
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}

const mapDispatchToProps = (dispatch) => ({
  passengerLogout: (option) => dispatch(passengerLogout(option)),
})

const mapStateToProps = (state) => ({
  isPassengerAuthenticated: !!state.app.passenger,
  passenger: state.app.passenger,
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
